// Открыт ли полноэкранный просмотр фото (лайтбокс). Признак общий на всё приложение:
// пока фото открыто, Escape должен закрывать ТОЛЬКО его. И карточка сделки (свой слушатель),
// и глобальные горячие клавиши (useHotkeys) сверяются с этим флагом — иначе одно нажатие
// Escape схлопнуло бы разом и фото, и карточку.
let open = false;
export const isLightboxOpen = () => open;
export const setLightboxOpen = (v: boolean) => { open = v; };
